const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBleatMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.26 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 55.26,
    width: 50,
    height: 43,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26,25.57c-.5,0-.94-.11-1.33-.33-.39-.22-.7-.55-.92-.99-.22-.45-.33-1.01-.33-1.69s.11-1.25,.34-1.69c.23-.44,.55-.77,.94-.98,.4-.22,.83-.33,1.31-.33,.58,0,1.09,.12,1.53,.37,.45,.25,.8,.6,1.06,1.05,.26,.45,.4,.98,.4,1.58s-.13,1.14-.4,1.58c-.26,.45-.61,.8-1.06,1.06-.44,.25-.95,.37-1.53,.37Zm-3.26-.08v-8.16H1.38v3.65l-.11,1.56,.04,1.56v1.39H0Zm3.1-1.1c.33,0,.62-.07,.88-.22,.26-.15,.47-.36,.63-.64,.15-.28,.23-.6,.23-.98s-.08-.71-.23-.98c-.15-.28-.36-.49-.63-.64-.26-.15-.55-.22-.88-.22s-.63,.07-.89,.22-.47,.36-.63,.64c-.15,.27-.23,.6-.23,.98s.08,.7,.23,.98,.36,.49,.63,.64c.26,.15,.56,.22,.89,.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.03,25.57c-.5,0-.94-.09-1.32-.27-.38-.19-.68-.48-.89-.86-.21-.39-.32-.88-.32-1.46v-3.35h1.38v3.17c0,.53,.12,.92,.35,1.19,.24,.26,.58,.38,1.02,.38,.32,0,.6-.07,.84-.2,.24-.13,.43-.33,.56-.59,.14-.26,.21-.59,.21-.98v-2.97h1.38v5.87h-1.31v-1.58l.23,.48c-.2,.38-.49,.67-.87,.88-.38,.2-.8,.3-1.25,.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03,25.49v-5.87h1.37v5.87h-1.37Zm.69-6.84c-.26,0-.47-.08-.64-.24-.16-.16-.24-.36-.24-.58s.08-.43,.24-.58c.17-.16,.38-.24,.64-.24s.47,.08,.63,.23c.17,.15,.25,.33,.25,.56,0,.24-.08,.45-.24,.62-.16,.16-.37,.24-.64,.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.21,25.49v-8.16h1.38v8.16h-1.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.89,25.57c-.65,0-1.14-.17-1.5-.5-.35-.34-.53-.83-.53-1.48v-5.27h1.38v5.24c0,.28,.07,.5,.21,.65,.15,.15,.35,.23,.6,.23,.31,0,.56-.08,.77-.24l.39,.98c-.16,.13-.36,.23-.59,.3-.23,.07-.48,.1-.73,.1Zm-2.99-4.81v-1.1h3.92v1.1h-3.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64,25.57c-.5,0-.94-.11-1.33-.33-.39-.22-.7-.55-.92-.99-.22-.45-.33-1.01-.33-1.69s.11-1.25,.34-1.69c.23-.44,.55-.77,.94-.98,.4-.22,.83-.33,1.31-.33,.58,0,1.09,.12,1.53,.37,.45,.25,.8,.6,1.06,1.05,.26,.45,.4,.98,.4,1.58s-.13,1.14-.4,1.58c-.26,.45-.61,.8-1.06,1.06-.44,.25-.95,.37-1.53,.37Zm-3.26-.08v-8.16h1.38v3.65l-.11,1.56,.04,1.56v1.39h-1.31Zm3.1-1.1c.33,0,.62-.07,.88-.22,.26-.15,.47-.36,.63-.64s.23-.6,.23-.98-.08-.71-.23-.98c-.15-.28-.36-.49-.63-.64-.26-.15-.55-.22-.88-.22s-.63,.07-.89,.22-.47,.36-.63,.64c-.15,.27-.23,.6-.23,.98s.08,.7,.23,.98c.15,.28,.36,.49,.63,.64,.26,.15,.56,.22,.89,.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.24,27.7c-.29,0-.57-.05-.86-.14-.29-.1-.52-.23-.72-.4l.55-1.01c.14,.12,.3,.22,.47,.3,.18,.07,.36,.11,.54,.11,.25,0,.45-.06,.6-.19s.3-.33,.43-.63l.34-.77,.11-.17,2.22-5.19h1.32l-2.75,6.35c-.18,.44-.39,.79-.62,1.05-.22,.26-.47,.44-.75,.54-.27,.1-.57,.15-.9,.15Zm1.21-2l-2.65-6.08h1.43l2.16,5.07-.94,1.01Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval-Copy",
    d: "M74.57,41.29c13.93,0,25.23-9.07,25.23-20.24S88.5,.8,74.57,.8s-25.23,9.07-25.23,20.24c0,5.38,1.92,9.59,6.19,13.21,1.56,1.32-5.21,6.48-4.38,7.03,.59,.4,7.88-4.23,9.28-3.46,4.03,2.19,8.9,3.46,14.13,3.46Z",
    style: {
      fill: "#f7d54d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.75,22.49c0,2.48-1.74,3.61-4.03,3.61-.98,0-1.85-.28-2.39-.79-.59,.48-1.6,.82-1.6,.57v-9.61c0-.52-.16-.76-.83-.99v-.26l2.87-.57v5.55c.52-.93,1.74-1.31,2.52-1.31,1.83,0,3.47,1.36,3.47,3.8Zm-2.34,.12c0-2.47-.61-3.27-1.95-3.27-1.11,0-1.7,.86-1.7,1.96v1.96c0,1.94,1.01,2.58,1.95,2.58,1.2,0,1.7-.86,1.7-3.22Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,25.69v.26h-3.36v-.26c.62-.17,.66-.82,.66-1.6v-7.81c0-.54-.16-.77-.82-1v-.26l2.87-.57v9.64c0,.85,.08,1.46,.65,1.6Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.61,22.25h-5.21c.13,1.51,.95,2.3,2.05,2.53,.88,.19,2.19-.12,2.6-.85l.28,.14c-.26,.8-1.23,2.02-3.42,2.02s-3.62-1.87-3.62-3.67c0-2.18,1.57-3.73,3.83-3.73,2.37,0,3.49,1.16,3.49,3.56Zm-2-.26c0-1.94-.67-3.04-1.57-3.04-.97,0-1.64,1.56-1.64,3.04h3.21Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.48,24.89l.28,.11c-.13,.49-.88,1.09-1.92,1.09,0,0-1.46,0-1.64-1.25-.25,.68-1.21,1.25-2.37,1.25,0,0-1.88,0-1.88-1.57,0-1.68,1.38-1.84,4.24-2.51v-.96c0-1.6-.95-2.41-2.08-1.85-.52,.25-.59,.51-.47,.52,.25,.03,.46,.14,.61,.34,.29,.4,.18,.94-.25,1.22-.43,.26-1,.17-1.29-.23-.2-.29-.21-.66-.05-.93,.16-.26,.38-.68,1.28-1.13,.74-.37,1.59-.31,1.59-.31,2.15,0,2.73,1.27,2.73,3.09v2.3s-.02,1.08,.79,1.08c0,0,.34,0,.44-.26Zm-3.29-2.61c-1.6,.34-2.15,1.06-2.15,1.85,0,0,0,1.02,1.06,1.02,.56,0,.93-.42,1.08-.79v-2.08Z",
    style: {
      fill: "#1f2a44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.29,24.46l.25,.14c-.33,.72-1.33,1.5-2.42,1.5-1.29,0-2.06-.49-2.06-2.36v-4.64h-.82l-.05-.26h.87v-2.07l2.05-.32v2.39h1.95l-.07,.26h-1.88v4.6c0,.86,.39,1.31,1.21,1.31,.47,0,.83-.31,.98-.54Z",
    style: {
      fill: "#1f2a44"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBleatMobile);
export default __webpack_public_path__ + "static/media/logo-bleat-mobile.0d653c04b407708577301c8318a3ed27.svg";
export { ForwardRef as ReactComponent };